import { getApiUrl } from './api.config';

// Corrected: PATCH to /api/TodoItems/reorder, body: { orderedIds, listId }
export async function reorderTodos(
  todoIds: number[],
  _userEmail: string, // not used
  listId?: number
): Promise<void> {
  const response = await fetch(getApiUrl('TodoItems/reorder'), {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ orderedIds: todoIds, listId }),
  });
  if (!response.ok) {
    throw new Error('Failed to reorder todos');
  }
  // Optionally parse response if needed
}
